import useHierarchy from "backend/hooks/elements/useHierarchy";
import { ICardElementWithChildren } from "backend/model/model";
import ProgressModal from "design/components/progress/ProgressModal";
import React from "react";
import Report from "reportengine/Report";
import Slide from "reportengine/Slide";
import TextElement from "reportengine/TextElement";
import { createReport, saveBlob } from "reportengine/createReport";
import reportContextToRequest from "./reportContextToRequest";
import InitiativeSlide from "./slides/InitiativeSlide";

const InitiativeReport = (
  props: React.PropsWithChildren<{
    item: ICardElementWithChildren;
    filetype: string;
    onClose?: () => void;
  }>
) => {
  const { item, filetype } = props;
  const {
    isLoading: isChildrenLoading,
    data: children,
    isPreviousData,
    isRefetching,
  } = useHierarchy(item.id);
  const [progress, setProgres] = React.useState(0);
  const [blob, setBlob] = React.useState<null | Blob>(null);

  if (isChildrenLoading || isPreviousData || isRefetching) {
    return null;
  }
  return (
    <div>
      <Report
        template="/templates/report_en.pptx"
        onNothingToRender={() => {}}
        onProgress={(value) => {
          setProgres(value);
          console.log("slide progress ", value);
        }}
        onReadyToRender={async (report) => {
          setProgres(95);
          const blob = await createReport(
            await reportContextToRequest(report, item.symbol, filetype)
          );
          setBlob(blob);
          setProgres(100);
        }}
      >
        <Slide index={0}>
          <TextElement slideElement="title">Initiative Details</TextElement>
          <TextElement slideElement="subtitle">{item.name}</TextElement>
          <TextElement slideElement="footer">
            {item.period?.name || ""}
          </TextElement>
        </Slide>
        <InitiativeSlide item={item} />
      </Report>
      <ProgressModal
        isOpen
        onClose={() => {
          if (props.onClose) {
            props.onClose();
          }
        }}
        isComplete={!!blob}
        cancelClickHandler={props.onClose}
        completedClickHandler={() => {
          if (blob) {
            saveBlob(`${item.symbol}.${filetype}`, blob);
          }
        }}
        downloadText="Download"
        progress={progress}
        statusText="Exporting..."
      />
    </div>
  );
};

export default InitiativeReport;
